// components/ArticleList.tsx
import React, { } from 'react';
import { TFunction } from 'next-i18next';
import { GetUsuarioBloqueado, ReportarUsuarioChat } from '@/objects/Chat';
import { useServices } from '@/context/ServicesProvider';
import Boton from '../elements/Boton';
import { LoginDatos } from '@/objects/User';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { azul, orange, red } from '@/constants/Colors';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { mostrarAlerta } from '../elements/Dialog';
import { AxiosResponse } from 'axios';
import { GetProcesoCompraBeseif } from '@/objects/Beseif';
import { Article } from '@/objects/Articles';
import { limpiarBeseif } from '@/util/StringsUtil';
import { mostrarWebAlert } from './LoadWebWidget';
import { urlBeseifComprar } from '@/util/BaseURL';
import Texto from '../elements/Texto';
import { textosMini } from '@/constants/Dimens';
import GppGoodIcon from '@mui/icons-material/GppGood';

interface Props {
  id_otro_usuario?: number;
  id_participante_2: number;
  id_chat: number;
  id_articulo: number;
  categoria: string;
  t: TFunction;
}

const HeaderChat: React.FC<Props> = ({ id_otro_usuario, id_participante_2, id_chat, id_articulo, categoria, t }) => {

  const { mensajesQueries, articulosQueries, beseifQueries } = useServices();

  const [usuarioBloqueado, setUsuarioBloqueado] = React.useState<number>(0);


  React.useEffect(() => {
    if (id_otro_usuario == null || !Number.isFinite(id_otro_usuario)) {
      return;
    }

    if (id_otro_usuario != undefined) {
      const datosUsuarioLoaded: LoginDatos | null = cargarDatosUsuario();
      const datosUsuario: GetUsuarioBloqueado = {
        idUser: Number(datosUsuarioLoaded?.id_user),
        idOtroUser: id_otro_usuario
      }

      mensajesQueries?.obtenerUsuarioBloqueado(datosUsuario).then((response: any) => {
        setUsuarioBloqueado(response.data);
      });
    }
  }, [id_otro_usuario]);

  function bloquearUsuario() {
    if(id_otro_usuario == null || !Number.isFinite(id_otro_usuario)) {
      return;
    }
    const datosUsuarioLoaded: LoginDatos | null = cargarDatosUsuario();
    const datosUsuario: GetUsuarioBloqueado = {
      idUser: Number(datosUsuarioLoaded?.id_user),
      idOtroUser: id_otro_usuario
    }

    mensajesQueries?.bloquearUsuario(datosUsuario).then((response: any) => {
      setUsuarioBloqueado(response.data);
    }
    );
  }

  function reportarUsuario() {
    mostrarAlerta({
      title: t('common:opciones.informacion'),
      content: t('contenido:chat.reportar_chat'),
      acceptText: t('common:opciones.avisar'),
      labelValueText: t('contenido:chat.indique_el_motivo'),
      showCancelButton: true,
      onAccept: (texto) => {
        const reportarUsuario: ReportarUsuarioChat = {
          idUser: Number(cargarDatosUsuario()?.id_user),
          id_chat: id_chat,
          texto: texto
        };

        mensajesQueries?.reportarUsuarioChat(reportarUsuario).then((response: AxiosResponse<number>) => {

          mostrarAlerta({
            title: t('common:opciones.informacion'),
            content: t('contenido:chat.se_ha_avisado'),
            showCancelButton: false
          });

        }).catch((error: any) => {

        });
      }
    });
  }

  async function abrirCompraBeseif() {
    const datosUsuarioLoaded: LoginDatos | null = cargarDatosUsuario();

    const premitir_comprar_libro = await beseifQueries?.premitir_comprar_libro({
      id_user: Number(datosUsuarioLoaded?.id_user),
      id_libro: id_articulo,
      categoria_libro: categoria as any
    });

    if (premitir_comprar_libro?.status == 200) {
      if (!premitir_comprar_libro?.data) {
        return;
      }
    }

    articulosQueries?.getLibro(categoria, id_articulo).then((response: AxiosResponse<Article>) => {

      const titulo = response.data.title;
      const precio = response.data.prize;
      const email_vendedor = response.data.contact_email;
      const id_article = response.data.id_article;

      const getProcesoCompraBeseif: GetProcesoCompraBeseif = {
        id_user: Number(cargarDatosUsuario()?.id_user),
        email_vendedor: email_vendedor,
        email_comprador: String(cargarDatosUsuario()?.email),
        nombre_articulo: limpiarBeseif(titulo),
        precio_articulo: precio.toString(),
        id_anuncio: id_article,
        categoria_articulo: categoria
      };

      beseifQueries?.obtenerComprarBeseif(getProcesoCompraBeseif).then((response: AxiosResponse<string>) => {
        if (response.status == 200) {
          const codigo = response.data;
          mostrarWebAlert({
            title: t('contenido:libro.opciones.compra_el_libro') + " " + titulo,
            urlCargar: `${urlBeseifComprar}${codigo}`
          });
        }
      }
      ).catch((error: any) => {

      });
    }).catch((error: any) => {

    });

    // const objBeseif: PostBeseifObj = {
    //   id_user: Number(cargarDatosUsuario()?.id_user)
    // };

    //   beseifQueries?.obtenerTokenBeseif(objBeseif).then((response: AxiosResponse<GetTokenBeseif>) => {
    //     const token = response.data.access_token;
    //     const tipoToken = response.data.token_type;


    // }).catch((error: any) => {

    // });

  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: "2px" }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '10px', marginTop: "-10px" }}>
        {(Number(id_participante_2) !== Number(cargarDatosUsuario()?.id_user)) &&
          <Boton height='30px' color={azul} startIcon={<ShoppingCartIcon />} texto={t("contenido:chat.comprar")} onClick={() => { abrirCompraBeseif() }} />
        }
        <Boton height='30px' width='150px' startIcon={usuarioBloqueado == 0 ? <PersonOffIcon /> : <PersonAddAlt1Icon />} color={red} texto={usuarioBloqueado == 0 ? t("contenido:chat.bloquear") : t("contenido:chat.desbloquear")} onClick={() => { bloquearUsuario() }} />
        <Boton height='30px' startIcon={<GppMaybeIcon />} color={orange} texto={t("contenido:chat.reportar")} onClick={() => { reportarUsuario() }} />
      </div>
      <div style={{ marginTop: "-10px" }}>
        <Texto fontSize={textosMini}>{t("contenido:chat.info_mensajes")}</Texto>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: "5px" }}>
        <GppGoodIcon style={{ color: azul, width: "15px", height: "15px", marginRight: "3px" }} />
        <Texto fontSize={textosMini}>{t("contenido:chat.conversacion_supervisada_por_ia")}</Texto>
      </div>
    </div>
  );
};

export default HeaderChat;
